//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"RouteCornerBendMethods",1,0],[0,"RouteCornerNumberOfMiters",1,0],[1,"RouteCornerRadius",0,"Expression",0],[1,"RouteCornerRatioToAttribute",0,"Expression",0],[0,"RouteCornerRatioToAttributeName",1,0],[1,"RouteCornerRatioToDiameter",0,"Expression",0],[0,"RouteCornerRequireLinearSolution",1,0],[0,"RouteCornerTypeOptions",1,0]],[[[],"RouteCornerSpecifyElbow",{},0,0],[[],"RouteCornerAlternateSolution",{},0,0],[[],"RouteCornerBendRadiusInfo",{},0,0],[[],"GetElbowPart",{R_:{elbowPart:"Routing.CharacteristicList"}},0,0],[["elbowPart"],"SetElbowPart",{},1,0],[[],"GetElbowAppliedCharx",{R_:{elbowPart:"Routing.CharacteristicList"}},0,0],[["elbowPart"],"SetElbowAppliedCharx",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Routing.CornerTypeBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.CornerTypeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.CornerTypeBuilder.Type = Object.freeze({
    "None" : "None", "Miter" : "Miter", "Bend" : "Bend", "SBend" : "SBend", "SElbow" : "SElbow", "UBend" : "UBend", "UElbow" : "UElbow", "Cope" : "Cope", "MiteredBend" : "MiteredBend"});

SPLM.Routing.CornerTypeBuilder.BendMethods = Object.freeze({
    "Radius" : "Radius", "RatioToDiameter" : "RatioToDiameter", "BendRadiusTable" : "BendRadiusTable", "InnerRadius" : "InnerRadius", "RatioToAttribute" : "RatioToAttribute"});

export default SPLM;